import { dashboardDrawerAtom } from "@/ui";
import { AnimatePresence, motion } from "framer-motion";
import { useAtom } from "jotai";
import { tabNavAtom, selectedTabAtom } from "../state";
import { useRouter } from "@/utils/router";
import { getSectionsForTab } from "../sectionConfig";
import clsx from "clsx";
import { useEffect } from "react";

export function SectionList() {
    const [isOpen] = useAtom(dashboardDrawerAtom);
    const [selectedNavTab] = useAtom(tabNavAtom);
    const [selectedSection, setSelectedSection] = useAtom(selectedTabAtom);
    const router = useRouter();

    const sections = getSectionsForTab(selectedNavTab);

    useEffect(() => {
        const urlSection = router.search.section as string;

        if (sections.length > 0) {
            if (urlSection && sections.find((s) => s.id === urlSection)) {
                setSelectedSection(urlSection);
            } else {
                const firstSection = sections[0].id;
                setSelectedSection(firstSection);
                router.updateSearch("section", firstSection);
            }
        }
    }, [sections, router.search.section, router, setSelectedSection]);

    const handleSectionClick = (sectionId: string) => {
        setSelectedSection(sectionId);
        router.updateSearch("section", sectionId);
    };

    return (
        <div>
            {isOpen && (
                <AnimatePresence>
                    <motion.div
                        layout
                        initial={{ opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <h2 className="heading-m mb-6 mt-2 shrink-0">
                            {selectedNavTab}
                        </h2>
                        <ul
                            className={clsx(
                                "flex flex-col",
                                "max-h-[calc(100vh-200px)] gap-2 overflow-y-auto",
                            )}
                        >
                            {sections.map((section) => {
                                const isActive = selectedSection === section.id;
                                return (
                                    <li key={section.id}>
                                        <span
                                            onClick={() =>
                                                !section.deactivated &&
                                                handleSectionClick(section.id)
                                            }
                                            className={clsx(
                                                "body-s block w-full text-left",
                                                "fade-container cursor-pointer rounded-lg p-2 pl-3",
                                                isActive
                                                    ? "bg-default text-primary font-medium"
                                                    : "text-color hover:bg-default hover:text-color bg-transparent",
                                                section.deactivated &&
                                                    "text-gray-400 hover:bg-transparent hover:text-gray-400",
                                            )}
                                        >
                                            {section.title}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </motion.div>
                </AnimatePresence>
            )}
        </div>
    );
}
